import * as React from 'react';
import { CustomButton, ButtonType } from "soprasteria-ui-library";

interface IReferralResponseButtons {
    canSendResponse: boolean;
}

export const ReferralResponseButtons: React.FunctionComponent<IReferralResponseButtons> = ({ canSendResponse }) => {

    return (
        <>
            {
                canSendResponse ?
                    <>
                        <CustomButton buttonType={ButtonType.deleteAlt} buttonText="Avvisa"
                            data-toggle="modal" data-target="#referral-reject-modal" id="open-referral-reject-modal" />
                        <CustomButton buttonType={ButtonType.general} buttonText="Begär komplettering"
                            data-toggle="modal" data-target="#referral-complement-modal" id="open-referral-complement-modal" />
                        <CustomButton buttonType={ButtonType.success} buttonText="Godkänn"
                            data-toggle="modal" data-target="#referral-approve-modal" />
                    </>
                    : null
            }
        </>
    )
}